
import { GrandTotalContainer } from "../../styles"
export default function GrandTotal({ amount }) {
    return (
        <GrandTotalContainer>
            <span>Grand Total: ${amount}</span>
        </GrandTotalContainer>
    )
}